import { useState, useRef, useEffect } from "react";
//import { useNavigate } from "react-router-dom";
//import { motion } from "framer-motion";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

import useHeroSlides from "../../Hooks/useHeroSlides";
import "../styles/Slider.css";

export default function HeroSlider() {
    //const navigate = useNavigate();
    const swiperRef = useRef(null);
    const [loaded, setLoaded] = useState({});
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (!swiperRef.current?.autoplay) return;

            if (document.hidden) {
                swiperRef.current.autoplay.stop();
            } else {
                swiperRef.current.autoplay.start();
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () =>
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange
            );
    }, []);



    const slides = useHeroSlides(); // ✅ HOOK HERE

    return (
        <Swiper
            modules={[Autoplay, Pagination, Navigation, EffectFade]}
            effect="fade"
            loop
            speed={800}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true, // 🔥 THIS FIXES EVERYTHING
            }}
            pagination={{ clickable: true }}
            navigation
            className="hero-swiper"
            onSwiper={(swiper) => (swiperRef.current = swiper)}
        >

            {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                    <div className="slide-wrapper">
                    <img
                        src={slide.img}
                        alt={slide.alt}
                        className={`swiper-img ${loaded[index] ? "loaded" : ""}`}
                        loading={slide.priority ? "eager" : "lazy"}     // ✅ native lazy
                        fetchpriority={slide.priority ? "high" : "auto"}
                        width="1200"
                        height="600"
                        onLoad={() =>
                            setLoaded((prev) => ({ ...prev, [index]: true }))
                        }
                    />

                    {/* ✅ Animated Overlay */}
                        {/* <motion.div
                        className="slide-content"
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                    >
                        <motion.h1
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2 }}
                        >
                            {slide.title}
                        </motion.h1>*/}

                            {/*<motion.p
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4 }}
                        >
                            {slide.subtitle}
                        </motion.p>*/}

                        {/* ✅ CTA Routing */}
                            {/*<motion.button
                            className="slide-btn"
                            whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onFocus={() => swiperRef.current?.autoplay?.stop()}
                                onBlur={() => swiperRef.current?.autoplay?.start()}
                            onClick={() => navigate(slide.link)}
                        >
                            {slide.cta}
                        </motion.button>*/}
                   {/* </motion.div>*/}
                </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
}
